module.exports = __webpack_public_path__ + "static/img/icon-band.fd1898f5.png";